var _circle, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#CB7D61"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#CB7D61"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25002 9.99989C7.21718 9.99994 7.18466 9.9935 7.15432 9.98093C7.12398 9.96837 7.09643 9.94993 7.07324 9.92668L5.32324 8.17683C5.30002 8.15362 5.28161 8.12606 5.26904 8.09573C5.25647 8.0654 5.25 8.03289 5.25 8.00006C5.24999 7.93375 5.27633 7.87016 5.32321 7.82327C5.37009 7.77638 5.43368 7.75003 5.49998 7.75003C5.56629 7.75002 5.62988 7.77636 5.67677 7.82324L7.25002 9.39636L10.5732 6.07324C10.6201 6.02635 10.6837 6 10.75 6C10.8163 6 10.8799 6.02634 10.9268 6.07322C10.9737 6.12011 11 6.1837 11 6.25001C11 6.31632 10.9737 6.37991 10.9268 6.4268L7.4268 9.92668C7.40361 9.94992 7.37605 9.96835 7.34572 9.98092C7.31538 9.99348 7.28286 9.99993 7.25002 9.99989Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckStatus);
export default __webpack_public_path__ + "static/media/check-status.b325e0911797e3ce8ed330e84ae0a09d.svg";
export { ForwardRef as ReactComponent };